import { render, staticRenderFns } from "./CaseFormPolicy.vue?vue&type=template&id=16466551&scoped=true&"
import script from "./CaseFormPolicy.vue?vue&type=script&lang=ts&"
export * from "./CaseFormPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFormPolicy.vue?vue&type=style&index=0&id=16466551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16466551",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VForm,VListItem})
